import { render, staticRenderFns } from "./SendMsg.vue?vue&type=template&id=3e3133dc&scoped=true&"
import script from "./SendMsg.vue?vue&type=script&lang=js&"
export * from "./SendMsg.vue?vue&type=script&lang=js&"
import style0 from "./SendMsg.vue?vue&type=style&index=0&id=3e3133dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3133dc",
  null
  
)

export default component.exports